import { render, staticRenderFns } from "./customerContributionRegionPage.vue?vue&type=template&id=53b95f50&scoped=true&"
import script from "./customerContributionRegionPage.vue?vue&type=script&lang=js&"
export * from "./customerContributionRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./customerContributionRegionPage.vue?vue&type=style&index=0&id=53b95f50&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b95f50",
  null
  
)

export default component.exports